<script setup lang="ts">

</script>

<template>
  <svg width="22" height="22" viewBox="0 0 22 22" class="tw-fill-namaGray dark:tw-fill-white" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0594 14H16.1234L21.5 19.3766L19.3766 21.5L14 16.1234V15.0594L12.7484 13.8078C11.4547 14.8672 9.8 15.5 8 15.5C3.85625 15.5 0.5 12.1437 0.5 8C0.5 3.85625 3.85625 0.5 8 0.5C12.1437 0.5 15.5 3.85625 15.5 8C15.5 9.8 14.8672 11.4547 13.8078 12.7484L15.0594 14ZM8 2C4.68594 2 2 4.68594 2 8C2 11.3141 4.68594 14 8 14C11.3141 14 14 11.3141 14 8C14 4.68594 11.3141 2 8 2Z"
      />
  </svg>
</template>

<style scoped>

</style>
